var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHumanSideways(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 113,
    viewBox: "0 0 124 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.6896 18.1474C61.6151 -5.28006 32.6746 -4.53411 18.4905 11.8733C-2.11464 35.7083 -14.9335 78.1343 32.6746 101.114C112.07 139.438 141.839 66.2595 113.519 57.2433C85.1979 48.2272 84.8323 30.802 76.6896 18.1474Z",
    fill: "#F5F5FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_725_6950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 124,
    height: 113
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6545 18.1474C61.5869 -5.28006 32.6596 -4.53411 18.482 11.8733C-2.11368 35.7083 -14.9267 78.1343 32.6596 101.114C112.019 139.438 141.774 66.2595 113.467 57.2433C85.1589 48.2272 84.7934 30.802 76.6545 18.1474Z",
    fill: "#F1F4FD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_725_6950)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5439 61.2372C51.1651 61.2372 53.2095 54.5075 56.403 50.8144C58.688 48.1721 62.5876 48.9599 63.7419 45.2608C66.6445 35.9588 58.8757 29.4119 48.7409 29.4119C38.606 29.4119 31.7724 35.1537 30.2969 43.7852C28.8214 52.4168 35.409 61.2372 45.5439 61.2372Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9065 60.0259C55.0915 61.9457 58.2209 62.8733 59.6899 62.4946C63.3734 61.5451 63.7121 48.0698 60.862 42.7574C58.0119 37.445 43.3599 35.1295 42.6214 45.655C42.3651 49.3081 43.899 52.5682 46.1653 55.2284L42.1016 74.1691H53.9057L51.9065 60.0259Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3886 38.265C34.3471 47.1181 43.4232 56.5279 45.91 56.5279C46.0705 55.2505 46.5602 54.0079 47.2777 52.8253C46.8967 52.3318 46.6709 51.718 46.6709 51.0528C46.6709 49.423 48.0266 48.1018 49.699 48.1018C50.2213 48.1018 50.7127 48.2307 51.1415 48.4575C54.7664 45.3661 59.3127 43.211 61.5701 42.7873C65.4964 42.0502 52.4302 29.4119 43.3886 38.265Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.4015 120.775L81.4688 107.183L76.8412 115.19L91.3294 123.732C94.9622 129.454 97.0958 131.927 97.7302 131.149C98.2651 130.494 98.02 129.776 97.7941 129.114C97.6182 128.598 97.454 128.117 97.6795 127.727C98.1944 126.836 101.103 127.346 103.843 127.949C106.583 128.551 105.949 127.205 105.366 126.503C102.777 124.413 99.4554 122.504 95.4015 120.775ZM13.2773 140.522C14.7186 137.598 19.6269 109.099 19.6269 109.099L29.905 109.14C29.905 109.14 20.3856 139.87 19.6269 141.751C18.6413 144.193 20.3155 147.742 21.4507 150.148C21.6264 150.521 21.7891 150.866 21.9271 151.175C20.3519 151.88 19.5952 151.028 18.7975 150.13C17.8964 149.115 16.943 148.042 14.6987 149.086C13.8316 149.489 13.0111 149.966 12.2094 150.432C9.44039 152.042 6.89661 153.52 3.43614 151.385C2.88753 151.047 2.28634 149.772 3.73889 148.776C7.35771 146.295 12.5727 141.952 13.2773 140.522Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.836 65.9713L53.089 65.2418C60.4112 83.5334 73.1952 100.154 91.4407 115.102L77.6534 131.853C59.41 110.567 48.1648 88.607 48.836 65.9713Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2969 119.418H68.1684C68.1684 119.418 55.0075 87.4182 55.0075 65.0509L43.5835 63.3488C34.6053 77.7883 32.0699 95.5664 30.2969 119.418Z",
    fill: "#DDE3E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.082 135.649C17.2237 88.9223 43.332 63.3488 43.332 63.3488L43.3411 63.3568C43.3426 63.3541 43.3441 63.3515 43.3456 63.3488H44.0914C45.4298 63.3948 48.1686 63.5148 48.1686 63.5148L50.9291 71.4035C51.3671 85.8308 56.0447 129.553 56.0447 129.553H31.2554C31.2976 131.558 31.3909 133.591 31.541 135.649H13.082Z",
    fill: "#2F3676"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2592 129.747C31.0613 121.017 31.8358 112.82 33.1278 105.402C33.8035 114.204 35.2158 124.796 38.1653 129.747H31.2592Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7451 114.5L48.9865 108.809V114.5H36.7451Z",
    fill: "white",
    fillOpacity: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanSideways);
export default __webpack_public_path__ + "static/media/human-sideways.999db18a1837b5c1d7b28165bd6fc5cb.svg";
export { ForwardRef as ReactComponent };